export default "__VITE_ASSET__24sxEthz__"